import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { Calendar, Tag } from "lucide-react";

export default function EventModal({ event, open, onClose }) {
  if (!event) return null;
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl bg-surface border-white/10 text-bone max-h-[90vh] overflow-y-auto p-0" data-testid="event-modal">
        <VisuallyHidden.Root>
          <DialogTitle>{event.title}</DialogTitle>
          <DialogDescription>{event.summary}</DialogDescription>
        </VisuallyHidden.Root>
        {event.image_url && (
          <div className="aspect-[16/9] w-full overflow-hidden">
            <img src={event.image_url} alt="" className="w-full h-full object-cover" />
          </div>
        )}
        <div className="p-6">
          <div className="flex items-center gap-3 mb-2">
            <span className="text-xs uppercase tracking-widest text-black bg-gold px-3 py-1 flex items-center gap-1"><Tag size={12} /> {event.tag}</span>
            <span className="text-bone/40 text-sm font-mono flex items-center gap-1"><Calendar size={13} /> {event.date}</span>
          </div>
          <h2 className="font-serif text-3xl md:text-4xl text-bone leading-tight mb-4">{event.title}</h2>
          <p className="text-gold/90 text-lg italic mb-5">{event.summary}</p>
          <div className="text-bone/70 leading-relaxed space-y-4 whitespace-pre-line">{event.content}</div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
